import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import KinderProgramComponent from "../../components/applicationComponents/kinderProgram/KinderProgramComponent";

export default function KinderProgramPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Kindergarten Program",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <KinderProgramComponent disabled={false} />
    </>
  );
}
